export default __webpack_public_path__ + "static/media/JHN-loho.fd0a63ad.png";